import { Component, For, Show } from "solid-js";
import { useScenarioStore } from "../stores/scenario";
import { formatSimTime } from "../types";

interface AnalysisModalProps {
	onClose: () => void;
}

const AnalysisModal: Component<AnalysisModalProps> = (props) => {
	const [scenario] = useScenarioStore();
	return (
		<div
			class="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50 p-4"
			onClick={props.onClose}
		>
			<div
				class="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[70vh] flex flex-col"
				onClick={(e) => e.stopPropagation()}
			>
				{/* Header */}
				<div class="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
					<h2 class="text-xl font-semibold text-gray-800">
						Analys - {scenario.analysis.scenarioName}
					</h2>
					<button
						class="text-gray-400 hover:text-gray-600 text-2xl leading-none"
						onClick={props.onClose}
					>
						×
					</button>
				</div>

				{/* Content - scrollable */}
				<div class="flex-1 overflow-y-auto px-6 py-5">
					{/* Ingress */}
					<Show when={scenario.analysis?.ingress && scenario.analysis.ingress.trim()}>
						<div class="mb-6 text-[15px] text-gray-700  ">
							<For
								each={scenario.analysis.ingress
									?.split("\n")
									.filter((p) => p.trim())}
							>
								{(paragraph) => (
									<p class="mb-2 last:mb-0">{paragraph}</p>
								)}
							</For>
						</div>
					</Show>{" "}
					{/* Sections */}
					<div class="space-y-6 mb-12">
						<For each={scenario.analysis.sections}>
							{(section) => (
								<div class="border-b border-gray-100 pb-4 last:border-b-0">
									<div class="flex items-baseline gap-2 mb-1">
										<span class="text-xs font-mono text-gray-400">
											{formatSimTime(section.time)}
										</span>
										
									</div>
									<Show
										when={
											section.headline &&
											section.headline.trim()
										}
									>
										<h3 class=" font-semibold text-gray-800 mb-2">
											{section.headline}
										</h3>
									</Show>
									<div class="text-[15px] text-gray-700 space-y-2">
										<For
											each={section.content
												.split("\n")
												.filter((p) => p.trim())}
										>
											{(paragraph) => <p>{paragraph}</p>}
										</For>
									</div>
								</div>
							)}
						</For>
					</div>{" "}
					<Show when={scenario.analysis.sections.length === 0}>
						<div class="text-center text-gray-400 py-8">
							Ingen analys tillgänglig för detta scenario.
						</div>
					</Show>
				</div>

				{/* Footer */}
				<div class="px-6 py-4 border-t border-gray-200 flex justify-end">
					<button
						class="px-4 py-2 text-sm font-medium bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition-colors"
						onClick={props.onClose}
					>
						Stäng
					</button>
				</div>
			</div>
		</div>
	);
};

export default AnalysisModal;
